<template>
    <section>
        <b-tabs position="is-centered" @input="changeTab" :multiline="true">
            <b-tab-item v-for="item in items" v-bind:key="item.content" :value="item.content" :label="item.tab"
                :icon="item.icon" :visible="item.visible" />
        </b-tabs>
        <!-- COMPONENTE AQUI -->
        <keep-alive>
            <component v-bind:is="currentTabComponent" :object-id="personId" :photo-url="photoUrl" :person="person"
                :component-type="'person'" :cargo-principal="cargoPrincipal" :currentYear="currentYear"
                :hide-update="true" :can-create-document="canCreateDocument" :permissions="permissions" />
        </keep-alive>

        <!-- FIN COMPONENTE -->
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import MyPerformances from "./my_performances_tab.vue"
import PerformancesTab from "../performances/performances_tab.vue"
export default {
    components: {
        MyPerformances, PerformancesTab,
    },
    props: [
        'personId', 'photoUrl', 'cargoPrincipal', 'canCreateDocument', 'currentYear', 'person', 'canDeclarePerformances', 'permissions'
    ],
    data() {
        return {
            isLoading: false,
            currentTab: 'PerformancesTab',
            items: [
                { tab: 'Mi Declaraciones de Desempeño', content: 'MyPerformances', icon: "tasks", visible: this.isAuthorized('PerformanceDeclarePerformance') },
                { tab: 'Evaluación y Calificación del Desempeño', content: 'PerformancesTab', icon: "list-alt", visible: true },
            ],
        }
    },

    created() {
        if (this.isAuthorized('PerformanceDeclarePerformance')) {
            this.currentTab = 'MyPerformances'
        } else {
            this.currentTab = 'PerformancesTab'
        }
    },

    methods: {
        changeTab: function (value) {
            this.currentTab = value
        },

        isAuthorized(name) {
            let permission = this.permissions.find(obj => obj.name === name)
            if (permission !== undefined) {
                return permission.value;
            }
            else {
                return false
            }
        },
    },
    computed: {
        currentTabComponent: function () {
            return this.currentTab
        }
    }
}
</script>